'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$7() {
  this.blg = null;
  this.ble = null;
  this.blf = false;
  this.blc = null;
  this.bld = false;
  this.blh = false;
  this.bli = false;
  this.blg = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_PrestoRouter$$anon$7 as $c_Lpresto_PrestoRouter$$anon$7 };
$p = $c_Lpresto_PrestoRouter$$anon$7.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$7;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$7() {
}
export { $h_Lpresto_PrestoRouter$$anon$7 as $h_Lpresto_PrestoRouter$$anon$7 };
$h_Lpresto_PrestoRouter$$anon$7.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ac = (function() {
  return this.blg;
});
$p.t = (function() {
  if ((!this.blf)) {
    this.ble = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.blf = true;
  }
  return this.ble;
});
$p.ad = (function() {
  if ((!this.bld)) {
    this.blc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bld = true;
  }
  return this.blc;
});
$p.v = (function() {
  if ((!this.bli)) {
    this.blh = false;
    this.bli = true;
  }
  return this.blh;
});
$p.ab = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_PrestoRouter$$anon$7 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$7, "presto.PrestoRouter$$anon$7", ({
  OM: 1,
  a: 1,
  j: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$7 as $d_Lpresto_PrestoRouter$$anon$7 };
//# sourceMappingURL=presto.-Presto-Router$$anon$7.js.map
